'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'icons';
var width = 576;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = ['M80 67c0 12.3 4.1 22 11.3 32.3 8.8 12.6 21.6 25.7 35.9 37.9 11.4 9.8 23 18.4 32.8 25.1 9.8-6.8 21.4-15.4 32.8-25.1 14.3-12.3 27.1-25.3 35.9-37.9 7.2-10.3 11.3-20 11.3-32.3 0-11.6-11.1-18.5-21.7-19.1-1.1-.1-3.3 0-8 2.8-18 10.3-50.3 39.7-50.3 39.7S127.7 61 109.7 50.7c-4.8-2.7-6.9-2.8-8-2.8-10.6 .6-21.7 7.5-21.7 19.1zm0 269l0 128 192 0 0-128-45.7 0-13.3-26.5-2.7-5.5-68.7 0-2.7 5.5-13.3 26.5-45.7 0zm136 56a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z', 'M544-5.3L544 176c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-76.2-112 22.4 0 132.3c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-125.2 19.3-3.9 160-32 28.7-5.7zM256 288l64 0 0 224-288 0 0-224 64 0 16-32 128 0 16 32zm16 48l-45.7 0-13.3-26.5-2.7-5.5-68.7 0-2.7 5.5-13.3 26.5-45.7 0 0 128 192 0 0-128zM109.7 50.7c-4.8-2.7-6.9-2.8-8-2.8-10.6 .6-21.7 7.5-21.7 19.1 0 12.3 4.1 22 11.3 32.3 8.8 12.6 21.6 25.7 35.9 37.9 11.4 9.8 23 18.4 32.8 25.1 9.8-6.8 21.4-15.4 32.8-25.1 14.3-12.3 27.1-25.3 35.9-37.9 7.2-10.3 11.3-20 11.3-32.3 0-11.6-11.1-18.5-21.7-19.1-1.1-.1-3.3 0-8 2.8-18 10.3-50.3 39.7-50.3 39.7S127.7 61 109.7 50.7zM32 67c0-37 30.1-65 67-67 24.4-1.3 42.9 13.8 57.7 25.9 1.1 .9 2.2 1.8 3.2 2.6 1.1-.9 2.1-1.7 3.2-2.6 14.8-12.1 33.3-27.3 57.7-25.9 37 2 67 30 67 67 0 68.5-74.3 121.7-128 152.4-53.7-30.7-128-83.9-128-152.4zM528 240l-57.6 128 81.6 0-184 160 57.6-128-81.6 0 184-160zM176 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;